


// src/redux/slices/branchSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const API_BASE = "https://narrowitsolution.in/api";

// export const getBranches = createAsyncThunk(
//   "branch/getBranches",
//   async ({ page = 1, limit = 10 }, { rejectWithValue }) => {
//     try {
//       const SuperAdminId = localStorage.getItem("adminuserId"); // 🔑 get from localStorage

//       const res = await axios.get(`${API_BASE}/get-branch`, {
//         params: {
//           page,
//           limit,
//           SuperAdminId, // ✅ filter applied
//         },
//       });

//       return res.data; // { branches, totalRecords }
//     } catch (err) {
//       return rejectWithValue(err.response?.data?.message || err.message);
//     }
//   }
// );

export const getBranches = createAsyncThunk(
  "branch/getBranches",
  async ({ page = 1, limit = 10, fetchAll = false }, { rejectWithValue }) => {
    try {
      const SuperAdminId = localStorage.getItem("adminuserId");

      // ✅ If fetchAll = true → get everything
      if (fetchAll) {
        const res = await axios.get(`${API_BASE}/get-branch`, {
          params: { SuperAdminId, limit: "all" }, // 👈 backend will handle "all"
        });

        return res.data; // all branches
      }

      // ✅ Otherwise → normal pagination
      const res = await axios.get(`${API_BASE}/get-branch`, {
        params: { page, limit, SuperAdminId },
      });

      return res.data; // paginated data
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || err.message);
    }
  }
);




// 🔹 Add Branch
export const addBranch = createAsyncThunk(
  "branch/addBranch",
  async (branchData, { rejectWithValue }) => {
    try {
      const res = await axios.post(`${API_BASE}/add-branch`, branchData);
      return res.data.branch; // ✅ backend should return created branch
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || err.message);
    }
  }
);

// 🔹 Update Branch
export const updateBranch = createAsyncThunk(
  "branch/updateBranch",
  async (branchData, { rejectWithValue }) => {
    try {
      const res = await axios.put(
        `${API_BASE}/update-branch/${branchData.id}`,
        branchData
      );
      return res.data.branch;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || err.message);
    }
  }
);

// 🔹 Delete Branch
export const deleteBranch = createAsyncThunk(
  "branch/deleteBranch",
  async (id, { rejectWithValue }) => {
    try {
      await axios.delete(`${API_BASE}/delete-branch/${id}`);
      return id;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || err.message);
    }
  }
);

const branchSlice = createSlice({
  name: "branch",
  initialState: {
    branches: [],
    totalRecords: 0,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Get Branches
      .addCase(getBranches.pending, (state) => {
        state.loading = true;
      })
      .addCase(getBranches.fulfilled, (state, action) => {
        state.loading = false;
        state.branches = action.payload.branches || [];
        state.totalRecords = action.payload.totalRecords || 0;
      })
      .addCase(getBranches.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Add Branch
      .addCase(addBranch.fulfilled, (state, action) => {
        state.branches.push(action.payload);
        state.totalRecords += 1;
      })

      // Update Branch
      .addCase(updateBranch.fulfilled, (state, action) => {
        const index = state.branches.findIndex(
          (b) => b.id === action.payload.id
        );
        if (index !== -1) {
          state.branches[index] = action.payload;
        }
      })

      // Delete Branch
      .addCase(deleteBranch.fulfilled, (state, action) => {
        state.branches = state.branches.filter((b) => b.id !== action.payload);
        state.totalRecords = state.branches.length;
      });
  },
});

export default branchSlice.reducer;
